import type { SpecType } from '@local/lib';

import type { SpecState } from '../quality-formulas/qualityFormulaTypes';

export interface LineQualityConfig {
  specStates: Record<SpecType, SpecState>;
  visibleSpecTypes: SpecType[];
}

export interface LineItemEntry {
  id: string;
  lineNumber: number;
  priceSummary: string;
  product: string;
  qualityConfig?: LineQualityConfig;
  shipmentSummary: string;
}

export const CONTRACT_NUMBER = 'PRE1726255';
export const getContractPath = (contractId: string = CONTRACT_NUMBER): string => `/contracts/${contractId}`;
export const getLineItemPath = (lineItemId: string, contractId: string = CONTRACT_NUMBER): string =>
  `${getContractPath(contractId)}/line-items/${lineItemId}`;
